export const bannerWrapperStyles = ({ palette }) => ({
  display: 'flex',
  gap: '12px',
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: palette.info.soft,
});

export const bannerIconWrapperStyles = ({ palette }) => ({
  display: 'flex',
  flexShrink: 0,
  color: palette.info.main,
});

export const bannerTextWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const bannerTitleStyles = ({ palette }) => ({
  color: palette.info.dark,
});

export const bannerBodyStyles = ({ palette }) => ({
  color: palette.info.dark,
});
